import React from 'react'
// @ts-ignore
import styled from 'styled-components'
import {
  background,
  border,
  color,
  compose,
  flexbox,
  grid,
  layout,
  position,
  shadow,
  space,
  typography,
  // @ts-ignore
} from 'styled-system'
import { print, interactive, spin } from '../styles'
import { filterProps } from '../utils'

const StyledBox = filterProps(styled.div)`
  ${compose(space, layout, typography, color, flexbox, grid, background, border, position, shadow)}
  ${print}
  ${interactive}
  ${spin}
`

const Box = React.forwardRef((props: any, ref) => <StyledBox {...props} ref={ref} />)

export default Box
